import React from 'react';
import { EditButton } from 'react-admin';

export default props => <EditButton label="View" icon={null} {...props} />;
